import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Faq } from '../../../data-access/models/faq.model';

@Injectable({
  providedIn: 'root',
})
export class FaqService {
  private faqUrl = 'wealth-assets/faq.json';

  constructor(private http: HttpClient) {
  }

  getFaq(): Observable<{ fixedIncome: Faq[]; stock: Faq[] }> {
    return this.http.get<any>(this.faqUrl);
  }
}
